var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBatteryRepairs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.202,
    height: 43.774,
    viewBox: "0 0 52.202 43.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4354",
    "data-name": "Group 4354",
    transform: "translate(-29.749 -32.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M7589.356-8950.558h-31.49a1.893,1.893,0,0,1-1.868-1.913v-28.66a1.892,1.892,0,0,1,1.868-1.911h1.365v-3.229a1.618,1.618,0,0,1,1.615-1.618h8.078a1.618,1.618,0,0,1,1.615,1.618v3.229h17.833v-3.229a1.618,1.618,0,0,1,1.615-1.618h8.078a1.618,1.618,0,0,1,1.615,1.618v3.229h2.98a1.892,1.892,0,0,1,1.868,1.911v14.523a11.848,11.848,0,0,0-1.868-.642v-13.882h-44.793v28.66h30.679a11.559,11.559,0,0,0,.811,1.912Zm.631-35.714v3.229h8.078v-3.229Zm-29.141,0v3.229h8.078v-3.229Zm31.167,17.632h-1.263v-2.526h-2.524v-1.261h2.524v-2.526h1.263v2.526h2.526v1.261h-2.526v2.525Zm-20.2-2.526H7565.5v-1.261h6.314v1.26Z",
    transform: "translate(-7526 9020.836)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6043",
    "data-name": "Path 6043",
    d: "M204.389,107.617a2.346,2.346,0,0,0-2.486.264,8.8,8.8,0,0,0-3.212,8.728,8.7,8.7,0,0,0,3.743,5.529v5.382h1.955v-6.49l-.489-.283h0a6.771,6.771,0,0,1-3.281-4.516,6.868,6.868,0,0,1,2.5-6.806.391.391,0,0,1,.427-.052.326.326,0,0,1,.192.326v3.812a2.281,2.281,0,0,0,2.281,2.281h2.606a2.281,2.281,0,0,0,2.281-2.281v-3.825a.326.326,0,0,1,.192-.326.4.4,0,0,1,.43.052,6.79,6.79,0,0,1,2.636,5.4,6.865,6.865,0,0,1-3.421,5.913l-.489.277v6.516h1.955v-5.405a8.822,8.822,0,0,0,3.91-7.3,8.734,8.734,0,0,0-3.388-6.93,2.349,2.349,0,0,0-2.476-.267,2.28,2.28,0,0,0-1.3,2.069v3.825a.325.325,0,0,1-.326.326h-2.606a.326.326,0,0,1-.326-.326v-3.819a2.28,2.28,0,0,0-1.3-2.075Z",
    transform: "translate(-134.166 -51.051)",
    fill: "#525252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBatteryRepairs);
export default __webpack_public_path__ + "static/media/icon_battery_repairs.3ba82ce0aff867f2d1d944e078bb569d.svg";
export { ForwardRef as ReactComponent };